import React from 'react';
import { ConnectionType, IConnectionDetailsDTO, KnovioLabel } from '../../../../../../api/connections.dao';
import { PassportConfigurationMode } from '../configure-passport-display.config';
import DefaultButton from '../../../../../global/default-button/default-button';
import { getKvThumbnailUrl } from '../../../../../../infrastructure/utils/knovio.utils';
import { AudioBridgeConfigurationForm } from './audio-bridge-configuration/audio-bridge-configuration-form';
import defaultLiveThumbnailImage from '../../../../../../images/default_live_thumbnail.png';
import { IPhoneNumbersSet } from '../../../../../../api/zoom.dao';
import { AbstractFormViewModelController } from '../../../../../../infrastructure/implementations/form-viewmodel-controller';
import { IAudioBridgeValues } from './audio-bridge-configuration/audio-bridge-configuration.viewmodel';

import './configure-passport-preview-popover.scss';
import { useIntl } from 'react-intl';
import { CONNECTION_DETAILS } from '../../../../../../constants/common-labels.constants';


interface IProps {
    passportLabel: string;
    passportDescription: string;
    connection: IConnectionDetailsDTO;
    otherConnections: boolean;
    connectButtonLabel: string;
    connectionDetailsEnabled: boolean;
    phoneNumbersSet: IPhoneNumbersSet[];
    passportConfigurationMode: PassportConfigurationMode;
    formVM: AbstractFormViewModelController;
    connectionType: string;
    className?: string;
    isConnectionGroup: boolean;
    audioBridgeValues?: IAudioBridgeValues;
}

export const ConfigurePassportPreviewPresentation = (props: IProps) => {
    const {
        passportLabel,
        passportDescription,
        connection,
        otherConnections,
        connectButtonLabel,
        connectionDetailsEnabled,
        phoneNumbersSet,
        passportConfigurationMode,
        formVM,
        connectionType,
        isConnectionGroup,
        className,
        audioBridgeValues,
    } = props;
    const intl = useIntl();
    const getPassportConfiguration = (): JSX.Element => {
        return (
            <div className='passport-preview-popover-body__display-configuration'>
                {passportLabel && (
                    <div className='passport-preview-popover-body__label-block'>
                        <div className='passport-preview-popover-body__label'>{passportLabel}</div>
                        <hr />
                    </div>
                )}
                {passportDescription && (
                    <div
                        className='passport-preview-popover-body__description'
                        dangerouslySetInnerHTML={{ __html: passportDescription }}
                    />
                )}
            </div>
        );
    };
    return (
        <form className='passport-preview'>
            <div className={className}>
                {getPassportConfiguration()}
                {connectionType === ConnectionType.AudioBridge &&
                    <AudioBridgeConfigurationForm
                        formVM={formVM}
                        connection={connection}
                        phoneNumbersSet={phoneNumbersSet}
                        isConnectionGroup={isConnectionGroup}
                        audioBridgeValues={audioBridgeValues}
                    />
                }

                {connectionType === ConnectionType.Knovio &&
                    <div className='disabled'>
                        <img
                            className='passport-preview-popover-body__thumbnail'
                            alt={`${KnovioLabel.OEStream} thumbnail`}
                            src={passportConfigurationMode === PassportConfigurationMode.MeetingConnection
                                ? getKvThumbnailUrl(connection.embedCodeId)
                                : defaultLiveThumbnailImage
                            }
                        />
                    </div>

                }
                {otherConnections && <>
                    <DefaultButton
                        text={connectButtonLabel || 'Connect to Meeting'}
                        modifier={['fat', 'confirm-safe']}
                        className='passport-preview-popover-body__connection-button'
                    />

                    {connectionDetailsEnabled && connection?.meetingInvitation && <div>
                        <div className='passport-preview-popover-body__connection-details'>{intl.formatMessage(CONNECTION_DETAILS)}</div>
                        <div className='passport-preview-popover-body__connection-details-text'>
                            {connection?.meetingInvitation}
                        </div>
                    </div>
                    }

                </>}
            </div>
        </form>
    );
};